import "./main.scss";
import {dataTableInit} from "@/scripts/data-table";
import ru from "@/scripts/datepicker-ru";
import "@common/modules/axios";

window.datepicker = {regional: {ru}};
window.dataTableInit = dataTableInit;
